import { createContext } from 'react';
import { ImportedLog } from '../TypeScript/interfaces';

export type GetGeoLogs = (
  logName: string,
  drillholeId: string | number,
) => Record<string, any>[];

export interface GeologContextInterface {
  addLogs: (
    logs: Record<string, Record<string | number, Record<string, any>[]>>,
  ) => void;
  getLogs: GetGeoLogs;
  logsMetadata: ImportedLog[];
  addLogsMetadata: (newLogsMetadata: ImportedLog[]) => void;
}

export const GeologContext: React.Context<GeologContextInterface> =
  createContext({} as GeologContextInterface);
